export default "__VITE_ASSET__7f8a01b3__"